import { createSlice } from "@reduxjs/toolkit";

type AuthField = {
  isLoading: boolean;
  isLoggedOut: boolean;
  user: any | null;
  token: string | null;
  refreshToken: string | null;
};

export type AuthStateType = {
  auth: AuthField;
};

const initialState: AuthStateType = {
  auth: {
    isLoading: true,
    isLoggedOut: false,
    user: null,
    token: null,
    refreshToken: null,
  },
};
// slice
export const authReducer = createSlice({
  name: "authReducer",
  initialState: initialState,
  reducers: {
    setLogin: (state, action) => {
      state.auth = {
        ...state.auth,
        isLoggedOut: false,
        user: action.payload.user,
        token: action.payload.token,
        isLoading: false,
      };
    },
    setLogout: (state) => {
      state.auth = {
        ...state.auth,
        isLoggedOut: true,
        user: null,
        token: null,
        refreshToken: null,
      };
    },
  },
});

export const { setLogin, setLogout } = authReducer.actions;
